// extracted by mini-css-extract-plugin
export const heroLayout = "hero-module--heroLayout--3qMEh";
export const heroTextLayout = "hero-module--heroTextLayout--Wjb2x";
export const heroTitle = "hero-module--heroTitle--1uL_N";
export const heroBlurb = "hero-module--heroBlurb--REsGZ";
export const heroText = "hero-module--heroText--1mJ-a";
export const heroContent = "hero-module--heroContent---qbPB";
export const heroImage = "hero-module--heroImage--2xkLw";